import {useMemo, useState} from 'react';
import {useInput} from '@/hooks/useInput';
import clsx from 'clsx';
import {Label} from '@/shadcn_components/ui/label';

export type AvatarInputProps = {
  label?: string;
  source: string;
  accept?: string;
  width?: number;
  height?: number;
  format?: (any) => any;
  parse?: (any) => any;
} & Partial<React.ComponentProps<'div'>>;

export const AvatarInput = ({
  source,
  accept = '*.*',
  width,
  height,
  format,
  parse,
  className,
  ...rest
}: AvatarInputProps) => {
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);
  // const [hover, setHover] = useState(false);
  const imageWidth = width || 128;
  const imageHeight = height || 128;

  // turn a browser dropped file structure into expected structure
  const transformFile = file => {
    if (!(file instanceof File)) {
      return file;
    }

    const preview = URL.createObjectURL(file);
    const transformedFile = {
      rawFile: file,
      src: preview,
      title: file.name,
    };

    return transformedFile;
  };

  const {
    field: {onChange, value},
  } = useInput({
    format: format || transformFile, //=>to render
    parse: parse || transformFile, //=>to model
    source,
    ...rest,
  });

  const selectFile = async event => {
    const f = event.target.files[0];
    setSelectedFile(f);
    onChange(f);
  };

  const previewUrl = useMemo(() => {
    if (typeof value === 'string' && value) return value;
    if (value?.url_thumb) return value.url_thumb;
    if (value?.url) return value.url;
    return value?.src || value;
  }, [value]);

  return (
    <div className={clsx('form-control w-full', className)}>
      <Label className='text-lg'>{rest.label}</Label>
      <div className="group relative h-36 w-36 border-2">
        <div className="flex items-center justify-center h-full w-full">
          {previewUrl && (
            <img style={{maxHeight: imageHeight, maxWidth: imageWidth}} src={previewUrl} />
          )}
        </div>
        <div className="h-full w-full absolute left-0 top-0 flex items-center justify-center">
          <label
            // variant="filled"
            // size="sm"
            // color="blue"
            className={clsx(
              'bg-blue-500 p-2 rounded-md hover:bg-blue-600 cursor-pointer text-white invisible group-hover:visible',
              {
                visible: !value,
              },
            )}>
            Chọn ảnh
            <input
              // id="contained-button-file"
              className="hidden"
              type="file"
              accept={accept}
              onChange={selectFile}
            />
          </label>
        </div>
      </div>
      <p>{selectedFile?.name ?? ''}</p>
    </div>
  );
};
